<particle-generic-analytics [failureResponse]="failureResponse"
                            [dataLoaded]="dataLoaded"
                            [invokeReload]="invokeReloadReport"
                            [reportInfo]="reportDetails"
                            (reset)="onResetReport($event)"
                            (refresh)="onRefreshReport($event)"
>
  <mat-form-field *ngIf="scenarios" style="width: 100%;" appearance="outline">
    <mat-label>Select Scenario</mat-label>
    <mat-select [value]="selectedScenario" (selectionChange)="onSelectScenarion($event)">
      <mat-option *ngFor="let scenario of scenarios"
                  [value]="scenario.scenarioId">{{scenario.scenarioName}}</mat-option>
    </mat-select>
  </mat-form-field>
</particle-generic-analytics>
